import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import useStudents from '@/hooks/useStudents'
import StackedList from '@components/StackedList'

import { StudentListHeader, StudentListItem } from '@components/StudentListItem'
import type { Student } from '@/services/contribution/contribution'
import { sort } from '@/util/sorters'

export default function StudentList() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { students, isLoading } = useStudents()

  if (isLoading) return <div>Loading...</div>

  if (!students) {
    return (
      <div>
        <h2 className='font-serif font-semibold text-2xl text-gray-700 text-center pb-3'>
          {t('content.components.current_students.title')}
        </h2>
        <div className='font-sans font-normal text-sm text-gray-700 text-center pb-3'>
          {t('content.components.upload_photo.subtitle')}
        </div>
      </div>
    )
  }

  if (students.length === 0) {
    return (
      <div>
        <h2 className='font-serif font-semibold text-2xl text-gray-700 text-center pb-3'>
          {t('content.components.current_students.title')}
        </h2>
        <div className='font-sans font-normal text-sm text-gray-700 text-center pb-3'>
          {t('content.components.current_students.empty_state_message')}
        </div>
      </div>
    )
  }

  return (
    <StackedList
      title={t('content.components.current_students.title')}
      Header={StudentListHeader}
      renderItem={({ item: student }: { item: Student }) => (
        <StudentListItem
          key={student.id ?? undefined}
          student={student}
          onClick={(student: Student) => navigate(`../student/${student.id}`)}
        />
      )}
      data={sort(students, 'STUDENT_ASC')}
      columns={['w-2/5 sm:w-1/3', 'w-3/5 sm:w-2/3']}
    />
  )
}
